module.exports = __webpack_public_path__ + "static/img/py.e16a905e.svg";